// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"3d292b97","365":"819eccf7","379":"e714cb01","533":"4164432a","685":"19142248","764":"8997ea3e","787":"686b33a8","856":"42b0c3ba","939":"a153b182","975":"ccdf3c33"}[chunkId] + ".chunk.js";
};